import React, { useContext, useState } from "react";
import { UserContext } from "./UserContext";
import axios from "axios";
import { useHistory } from "react-router-dom";

const ChangePasswordComponent = () => {
  const [user] = useContext(UserContext);
  const [input, setInput] = useState({
    current_password: "",
    new_password: "",
    new_confirm_password: "",
  });
  const history = useHistory();

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post(
        "https://backendexample.sanbersy.com/api/change-password",
        {
          current_password: input.current_password,
          new_password: input.new_password,
          new_confirm_password: input.new_confirm_password,
        },
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          alert("Ganti Password Sukses");
          history.push("/");
        }
      })
      .catch((err) => {
        console.log(JSON.stringify(err.response.data));
      });
  };

  const handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    switch (name) {
      case "password": {
        setInput({ ...input, current_password: value });
        break;
      }
      case "password2": {
        setInput({ ...input, new_password: value });
        break;
      }
      case "password3": {
        setInput({ ...input, new_confirm_password: value });
        break;
      }
      default: {
        break;
      }
    }
  };

  return (
    <>
      <div style={{ margin: "0 auto", width: "25%", padding: "50px" }}>
        <form onSubmit={handleSubmit}>
          <label>Password: </label>
          <input
            type="password"
            name="password"
            onChange={handleChange}
            value={input.current_password}
          />
          <br />
          <label>New Password: </label>
          <input
            type="password"
            name="password2"
            onChange={handleChange}
            value={input.new_password}
          />
          <br />
          <label>New Confirm Password: </label>
          <input
            type="password"
            name="password3"
            onChange={handleChange}
            value={input.new_confirm_password}
          />
          <br />
          <button className="mt-2">Change</button>
        </form>
      </div>
    </>
  );
};

export default ChangePasswordComponent;
